import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationLogEntries.ts
function useLocationLogEntries(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryList.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntries };

//# sourceMappingURL=useLocationLogEntries.js.map